import React from "react";
import ExpandSwitches from "./ExpandSwitches";
import {PropTypes} from "prop-types";

class ExpandSwitchesContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            menuOpened: undefined
        }
    }

    handleCollapseGroupClicked = (groupKey) => {
        const { menuOpened } = this.state;
        this.setState({
            menuOpened: menuOpened === groupKey? undefined : groupKey
        });
    };

    render() {
        return (
            <ExpandSwitches
                {...this.props}
                {...this.state}
                handleCollapseGroupClicked={this.handleCollapseGroupClicked}
            />
        )
    }
}

ExpandSwitchesContainer.propTypes = {
    isOpen: PropTypes.bool,
    handlePermissionChanged: PropTypes.func.isRequired,
    handlePermissionGroupChanged: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    permissionGroups: PropTypes.arrayOf(
        PropTypes.shape({
            groupKey: PropTypes.string,
            permissions: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                    value: PropTypes.bool.isRequired
                })
            ).isRequired
        })
    )
};

export default ExpandSwitchesContainer;